import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { Card } from '@mui/material';
import { Box, Typography, TucarTheme } from '@tucar/pit-stop';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import GET_CHARGING_STATION from '../../../../graphql/querys/map/getChargingStation';

const StationInfoCard = ({ connectorId }) => {
  const { data, loading, error } = useQuery(GET_CHARGING_STATION.query, {
    ...GET_CHARGING_STATION.policies,
    variables: {
      connectorId,
    },
    skip: !connectorId,
  });
  if (loading || error || !data?.getChargingStation) {
    return null;
  }

  const station = data.getChargingStation;

  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        width: '100%',
        padding: '10px',
      }}
    >
      <Typography fontSize={16} weight="semi-bold" color={TucarTheme.colors.gray800}>
        {station.provider?.name || 'Proveedor Desconocido'}
      </Typography>
      <Typography fontSize={12} color={TucarTheme.colors.gray500}>
        Estación de carga
      </Typography>
      <Box
        sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'flex-start', gap: '5px' }}
      >
        <LocationOnIcon sx={{ fontSize: '17px', color: TucarTheme.colors.blue400 }} />
        <Typography fontSize={13} color={TucarTheme.colors.gray800}>
          {station.addressAlias || station.address}
        </Typography>
      </Box>
    </Card>
  );
};

StationInfoCard.propTypes = {
  connectorId: PropTypes.string,
};

StationInfoCard.defaultProps = {
  connectorId: null,
};

export default StationInfoCard;
